import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useBlogsList() {
    // Use toast
    const toast = useToast();

    const refBlogListTable = ref(null);

    // Table Handlers
    // Alineación estándar de las tablas del panel (mismo patrón que revisiones-admin):
    // `...styleTable` centra cabecera y contenido; `thClass: styleTable.thClass`
    // centra solo la cabecera y deja el contenido a la izquierda.
    const styleTable = {
        thClass: 'text-center',
        tdClass: 'text-center'
    };

    let tableColumns = [
        { key: 'title', sortable: true, label: 'Título', thClass: styleTable.thClass },
        { key: 'doctor_fullname', sortable: true, label: 'Autor', thClass: styleTable.thClass },
        { key: 'tags', sortable: false, label: 'Etiquetas', ...styleTable },
        { key: 'blog_state_name', sortable: true, label: 'Estado', ...styleTable },
        { key: 'published_at', sortable: true, label: 'Fecha publicada', labelHtml: 'Fecha <br> publicada', ...styleTable },
        { key: 'actions', sortable: false, label: 'Opciones', ...styleTable }
    ];

    const perPage = ref(10);
    const totalBlogs = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('');
    const isSortDirDesc = ref(true);

    const dataMeta = computed(() => {
        const localItemsCount = refBlogListTable.value ? refBlogListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBlogs.value,
        }
    });

    const refetchData = () => {
        refBlogListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData();
    });

    const fetchBlogs = (ctx, callback) => {
        store
            .dispatch('app-blog/fetchBlogs', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value
            })
            .then(response => {
                const { blogs, total } = response.data;
                callback(blogs);
                totalBlogs.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de blogs',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            })
    };

    return {
        fetchBlogs,
        tableColumns,
        perPage,
        currentPage,
        totalBlogs,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refBlogListTable,

        refetchData
    }
}
